import { request } from "@/store";
import Filter from "@/store/filter";
import { makeArrayUnique } from "@/utils";
var _ = require("lodash");
const demand_forecasting = {
  state: {
    list: [],
    download_list: [],
    total_rows: null,
    sellers_filter: new Filter([], []),
    products_filter: new Filter([], []),
    segments_filter: new Filter([], []),
    demand_forecasting_settings: [],
    keyword_list: [],
    demand_forecasting_settings_initialized: false,
    df_manual_override_active: false,
    filterManager: null
  },
  mutations: {
    demandForecastingSellersFilterSet(state, payload) {
      state.sellers_filter.restore(payload);
    },
    demandForecastingSegmentsFilterSet(state, payload) {
      state.segments_filter = payload;
    },
    demandForecastingListSet(state, payload) {
      state.list = payload;
    },
    demandForecastingKeywordsListSet(state, payload) {
      state.keyword_list = payload;
    },
    demandForecastingListSetToDownload(state, payload) {
      state.download_list = payload;
    },
    demandForecastingSettingsUpdate(state, payload) {
      state.demand_forecasting_settings.push(payload);
      state.demand_forecasting_settings = makeArrayUnique(state.demand_forecasting_settings);
    },
    demandForecastingListProductDataSet(state, payload) {
      state.list = state.list.map(item => {
        let product_data_items = payload.find(product_data => product_data.sku === item.sku);
        this.commit("demandForecastingManualOverrideActiveSet", product_data_items);
        return {
          ..._.mergeWith({}, item, product_data_items, (o, s) => _.isNull(s) ? o : s),
          orderable: product_data_items?.orderable === false ? false : true
        };
      });
    },
    demandForecastingListProductDataSetToDownload(state, payload) {
      //our existing merge logic (unchanged)
      state.download_list = state.download_list.map(item => {
        const product_data_items = payload.find(product_data => product_data.sku === item.sku);
        return {
          ..._.mergeWith({}, item, product_data_items, (o, s) => _.isNull(s) ? o : s),
          orderable: product_data_items?.orderable === false ? false : true
        };
      });

      //NEW: normalize so every row has the same keys (and no undefineds),load dash was discarding in json file generation,so added this patch
      const allKeys = Array.from(state.download_list.reduce((set, row) => {
        Object.keys(row).forEach(k => set.add(k));
        return set;
      }, new Set()));
      state.download_list = state.download_list.map(row => {
        const normalized = {};
        for (const k of allKeys) {
          normalized[k] = row[k] === undefined ? null : row[k];
        }
        return normalized;
      });
    },
    // old merging logic.
    // demandForecastingListProductDataSetToDownload(state, payload) {

    //   state.download_list = state.download_list.map((item) => {
    //     let product_data_items = payload.find(
    //       (product_data) => product_data.sku === item.sku
    //     );
    //     return {
    //       ..._.mergeWith({}, item, product_data_items, (o, s) =>
    //         _.isNull(s) ? o : s
    //       ),
    //       orderable: product_data_items?.orderable === false ? false : true,
    //     };
    //   });
    // },

    demandForecastingTotalRowsSet(state, payload) {
      state.total_rows = payload;
    },
    demandForecastingManualOverrideActiveSet(state, payload) {
      state.df_manual_override_active = Boolean(state.df_manual_override_active || payload?.manual_override);
    },
    demandForecastingManualOverrideActiveReset(state, payload) {
      state.df_manual_override_active = payload;
    },
    demandForecastingSettingsListSet(state, payload) {
      state.demand_forecasting_settings = payload;
      state.demand_forecasting_settings_initialized = true;
    },
    demandForecastingSetFilterManager(state, payload) {
      state.filterManager = payload;
    }
  },
  getters: {
    dfSellersFilterValuesIdsGet(state) {
      return () => {
        return state.sellers_filter.filterValues;
      };
    },
    dfGetProductSkus(state) {
      return () => {
        return state.list.map(product => product.sku);
      };
    },
    dfGetProductAsins(state) {
      return () => {
        return state.list.map(product => product.asin);
      };
    },
    dfGetProductIds(state) {
      return () => {
        return state.list.map(product => [product.seller_id, product.asin, product.sku]);
      };
    },
    demandForecastingSettingsForAccountGet(state) {
      return seller_id => {
        if (!seller_id) {
          return state.demand_forecasting_settings.slice(-1).pop();
        }
        if (state.demand_forecasting_settings.length > 1) {
          return state.demand_forecasting_settings.find(settings => settings.seller_id === seller_id);
        }
        return state.demand_forecasting_settings.slice(-1).pop();
      };
    },
    dfGetFilteredProductAsins(state) {
      return () => {
        return state.products_filter.selected.map(product => product.asin).filter(Boolean);
      };
    },
    dfGetFilteredProductSkus(state) {
      return () => {
        return state.products_filter.selected.map(product => product.sku).filter(Boolean);
      };
    },
    dfProductsGetSkus(state) {
      return () => {
        return Filter.merge({
          source1: "sku_list",
          source2: "sku"
        }, state.segments_filter.selected, state.products_filter.selected);
      };
    },
    dfProductsGetAsins(state) {
      return () => {
        return Filter.merge({
          source1: "asin_list",
          source2: "asin"
        }, state.segments_filter.selected, state.products_filter.selected);
      };
    }
  },
  actions: {
    async demandForecastingList({
      commit
    }, payload) {
      let result = (await request("/inventory/demand_forecasting", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        //console.log("[result from server table list]");
        //console.log(result);
        commit("demandForecastingListSet", result.data);
        commit("demandForecastingTotalRowsSet", result.total_rows);
      }
      return result;
    },
    async demandForecastingListToDownload({
      commit
    }, payload) {
      let result = (await request("/inventory/demand_forecasting", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        commit("demandForecastingListSetToDownload", result.data);
        commit("demandForecastingTotalRowsSet", result.total_rows);
      }
      return result;
    },
    async inventoryUpdateProductData({
      state
    }, payload) {
      let result = await request("/inventory/update_product_data", "POST", payload);
      return result;
    },
    async demandForecastingSuggestionList({
      commit
    }, payload) {
      let result = (await request("/inventory/demand_forecasting", "POST", payload)) ?? {
        data: []
      };
      return result;
    },
    async inventoryUpdateProductDataAll({
      state
    }, payload) {
      //console.log("[sending data to server]");
      //console.log(payload);
      let result = await request("/inventory/update_product_data_on_manual_override_all", "POST", payload);
      return result;
    },
    async inventoryCreateOrderCsv({
      state
    }, payload) {
      let result = await request("/inventory/create_order_csv", "POST", payload);
      return result;
    },
    async inventoryCreateOrderGoogleSheet({
      state
    }, payload) {
      let result = await request("/inventory/generate_google_sheet", "POST", payload);
      if (result) {
        return result;
      }
    },
    async inventoryProductDataList({
      commit
    }, payload) {
      let result = (await request("/inventory/get_product_data_by_id", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        commit("demandForecastingListProductDataSet", result.data);
      }
      return result;
    },
    async inventoryProductDataListToDownload({
      commit
    }, payload) {
      let result = (await request("/inventory/get_product_data_by_id", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        //console.log("Fetched rows:", result.data);
        commit("demandForecastingListProductDataSetToDownload", result.data);
      }
      return result;
    },
    async demandForecastingSettingsSave({
      state
    }, payload) {
      let result = await request("/inventory/update_demand_forecasting_settings", "POST", payload);
      return result;
    },
    async inventoryGetDemandForecastingSettings({
      commit
    }, payload) {
      let result = (await request("/inventory/get_demand_forecasting_settings", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        commit("demandForecastingSettingsListSet", result.data);
      }
      return result;
    },
    async demandForecastingSegmentsList({
      commit
    }, payload) {
      let result = (await request("/inventory/demand_forecasting/filters/segments", "POST", payload)) ?? {
        segments: []
      };
      if (result.segments) {
        commit("demandForecastingSegmentsFilterSet", new Filter(result.segments, [], "product_segment"));
      }
      return result;
    },
    demandForecastingSetFilterManager({
      commit
    }, filterManager) {
      commit("demandForecastingSetFilterManager", filterManager);
    }
  }
};
export default demand_forecasting;